/**
 * Faz 9 vitrin metinleri (öneriler, yeniden alım zamanı, yapay zekâ görsel notu). Vitrin girişi
 * (`@zt/i18n/storefront`) yalnızca `storefront.*` gördüğü için `storefront.en.ts` → `storefrontEn.ai` altına bağlanır.
 */
export const storefrontAiEn = {
  alsoBought: 'Customers who bought this also bought',
  cartRecommendations: 'You may also add',
  replenishmentTitle: 'Time to reorder',
  replenishmentLead: 'Estimated from your previous orders; you can add them to your cart now if you like.',
  replenishmentDue: 'Estimated reorder: {{date}}',
  aiImage: 'AI-generated image',
  replenishmentOverdue: 'Estimated reorder date has passed ({{date}})',
  replenishmentBasis: {
    own: 'you buy it about every {{days}} days',
    typical: 'this product is usually bought every {{days}} days',
  },
};
